import { render, staticRenderFns } from "./screens-report.vue?vue&type=template&id=44a18a9f&scoped=true"
import script from "./screens-report.vue?vue&type=script&lang=js"
export * from "./screens-report.vue?vue&type=script&lang=js"
import style0 from "./screens-report.vue?vue&type=style&index=0&id=44a18a9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a18a9f",
  null
  
)

export default component.exports